import React, {PureComponent} from 'react';
import {
    Row, Col, Breadcrumb, BreadcrumbItem,
} from 'reactstrap';

import 'react-toastify/dist/ReactToastify.css';
import Widget from '../../components/Widget';
import {SectionalFilter} from './../../components/filter/SectionalFIlter'
import TimeFilter from "../../components/filter/TimeFilter";
import {MonthFilter} from "../../components/filter/MonthFilter";
import {ProductividadMes} from './objects/productividad'
import {ProductividadEstado} from "./objects/productividadPorEstado";
import PieChart from "./charts/PieChart";
import PubSub from "pubsub-js";

export class Productividad extends PureComponent {

    state = {
        productividadMes: new ProductividadMes(0,0,0),
        productividadEstado: [],
        // data : [],
        // compliance: [],
        // totalCompliance: []
    }
    onChangehandle(e){
        this.setState({
            maxYear: e.target.value
        }, () => {
            PubSub.publish('reloadmaxYear', 'Reloading maxYear');
        })
    }

    onLoading = (showModal) => {
        this.setState({
            showModal: showModal
        })
    }
    API_URL = "/productivity";
    API_SECCIONAL = "/sectional"
    API_SECCIONAL_ESTADO = "/sectionalByState?seccional="


    componentDidMount() {
        var structure = new ProductividadMes();
        fetch(this.API_URL)
            .then((res) => res.json())
            .then((data1) => {
                //var structure = new ProductividadMes(0,0,0)
                data1.map(item => {
                    structure.Afiliaciones = item.afiliaciones
                    structure.AfiliacionesEfectivas = item.afiliaciones_efectivas
                    structure.Cumplimiento = (100 * structure.AfiliacionesEfectivas)/structure.Afiliaciones
                });
                this.setState(() => ({
                    productividadMes: structure
                }))
            });
        var structure1 = []
        fetch(this.API_SECCIONAL_ESTADO)
            .then((res) => res.json())
            .then((data1) => {
                data1.map(item => {
                    var estado = new ProductividadEstado(item.estado, item.conteo)
                    structure1.push(estado)
                });
                });
                this.setState(() => ({
                    productividadEstado: structure1
                }));
    }


    render() {
        return(
            <div>
                <Breadcrumb>
                    <BreadcrumbItem>Estas en</BreadcrumbItem>
                    <BreadcrumbItem active>Regionales</BreadcrumbItem>
                </Breadcrumb>
                <h1 className="page-title mb-lg"><span className="fw-semi-bold">Regionales</span></h1>
                <Row>
                    <Col xs={12} md ={4}>
                        <Widget>
                            <TimeFilter
                                handleChange={this.onChangehandle}
                                onLoading={this.onLoading}
                            />
                        </Widget>
                    </Col>
                    <Col xs={12} md ={4}>
                        <Widget>
                            <MonthFilter />
                        </Widget>
                    </Col>
                    <Col xs={12} md ={4}>
                        <Widget>
                            <SectionalFilter />
                        </Widget>
                    </Col>

                                <Col xs={12} md ={2}>
                                    <Widget title={<h5> <span className="fw-semi-bold">Afiliaciones</span></h5>}>
                                        <h1>{this.state.productividadMes.Afiliaciones}</h1>
                                    </Widget>
                                </Col>

                    <Col xs={12} md ={2}>
                        <Widget title={<h5> <span className="fw-semi-bold">Afiliaciones efectivas</span></h5>}>
                            <h1>{this.state.productividadMes.AfiliacionesEfectivas}</h1></Widget>
                    </Col>

                    <Col xs={12} md ={2}>
                        <Widget title={<h5> <span className="fw-semi-bold">Cumplimiento</span></h5>}>
                            <h1>{Number((this.state.productividadMes.Cumplimiento).toFixed(2))}%</h1>
                        </Widget>
                    </Col>

                    <Col xs={12} md={4}>
                        <Widget
                            title={<h5><span className="fw-semi-bold">Por Estado</span></h5>}>
                            <PieChart data={this.state.productividadEstado} />
                        </Widget>
                    </Col>

                </Row>
            </div>
        )
    }
}

export default Productividad;